import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        redirect: '/home_page',
        component: () =>
            import ('@/views/Home/Home.vue'),

        children: [

            //首页
            {
                path: '/home_page',
                name: 'home_page',
                meta: {
                    title: '首页',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Home/home_page/home_page.vue'),

            },

            //关于我们
            {
                path: '/about_Us',
                name: 'about_Us',
                meta: {
                    title: '关于我们',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Home/about_Us/about_Us.vue')
            },

            //相关资讯
            {
                path: '/message',
                name: 'message',
                meta: {
                    title: '相关资讯',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Home/message/message.vue')
            },
            // {
            //     path: '/contact_Us',
            //     name: 'contact_Us',
            //     meta: {
            //         title: '联系我们',
            //         keepAlive: true
            //     },
            //     component: () =>
            //         import ('@/views/Home/contact_us/contact_Us.vue')
            // },

            //相关咨询详情
            {
                path: '/page1',
                name: 'page1',
                meta: {
                    title: '相关资讯',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Home/message/page1.vue')
            },

            {
                path: '/page2',
                name: 'page2',
                meta: {
                    title: '相关资讯',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Home/message/page2.vue')
            },
            {
                path: '/page3',
                name: 'page3',
                meta: {
                    title: '相关资讯',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Home/message/page3.vue')
            },
            {
                path: '/page4',
                name: 'page4',
                meta: {
                    title: '相关资讯',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Home/message/page4.vue')
            },
            {
                path: '/page5',
                name: 'page5',
                meta: {
                    title: '相关资讯',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Home/message/page5.vue')
            },
            {
                path: '/page6',
                name: 'page6',
                meta: {
                    title: '相关资讯',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Home/message/page6.vue')
            },
            {
                path: '/page7',
                name: 'page7',
                meta: {
                    title: '相关资讯',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Home/message/page7.vue')
            },
            {
                path: '/page8',
                name: 'page8',
                meta: {
                    title: '相关资讯',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Home/message/page8.vue')
            },

            { //联系我们
                path: '/contact_us',
                name: 'contact_us',
                meta: {
                    title: '相关资讯',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Home/contact_us/contact_us.vue')
            },


        ]
    },
    { //忘记密码
        path: '/forgetPassword',
        name: 'forgetPassword',
        meta: {
            title: '忘记密码',
        },
        component: () =>
            import ('@/views/Home/forgetPassword/forgetPassword.vue')
    },
    { //注册页
        path: '/Register',
        name: 'Register',
        meta: {
            title: '注册',
        },
        component: () =>
            import ('@/views/Home/Register/Register.vue')
    },

    {
        path: '/B_Home',
        name: 'B_Home',
        redirect: '/Console',
        meta: {
            title: '控制台',
            keepAlive: true
        },
        component: () =>
            import ('@/views/Home/B_Home/B_Home.vue'),
        children: [{ //首页
                path: '/Console',
                name: 'Console',
                meta: {
                    title: '首页',
                },
                component: () =>
                    import ('@/views/Home/B_Home/Console/Console.vue')
            },
            //-------------
            { //岗位管理
                path: '/job_manage',
                name: 'job_manage',
                meta: {
                    title: '岗位管理',
                },
                component: () =>
                    import ('@/views/Home/B_Home/job_manage/job_manage.vue')
            },
            { //全职职位发布
                path: '/job_full',
                name: 'job_full',
                meta: {
                    title: '岗位发布',
                },
                component: () =>
                    import ('@/views/Home/B_Home/job_manage/job_full/job_full.vue')
            },
            //------------
            { //报名管理
                path: '/Management',
                name: 'Management',
                meta: {
                    title: '报名管理',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Home/B_Home/Management/Management.vue')
            },
            { //简历管理详情
                path: '/resume_manage_detail',
                name: 'resume_manage_detail',
                meta: {
                    title: '简历管理详情',
                },
                component: () =>
                    import ('@/views/Home/B_Home/resume_manage/resume_manage_detail.vue')
            },
            { //面试管理
                path: '/interview_manage',
                name: 'interview_manage',
                meta: {
                    title: '面试管理',
                },
                component: () =>
                    import ('@/views/Home/B_Home/interview_manage/interview_manage.vue')
            },
            { //面试管理
                path: '/interview_manage_detail',
                name: 'interview_manage_detail',
                meta: {
                    title: '面试邀约详情',
                },
                component: () =>
                    import ('@/views/Home/B_Home/interview_manage/interview_manage_detail.vue')
            },

            { //人才列表
                path: '/talents_list',
                name: 'talents_list',
                meta: {
                    title: '人才列表',
                },
                component: () =>
                    import ('@/views/Home/B_Home/talents_list/talents_list.vue')
            },
            { //人才详情
                path: '/talents_details',
                name: 'talents_details',
                meta: {
                    title: '人才详情',
                },
                component: () =>
                    import ('@/views/Home/B_Home/talents_list/talents_details/talents_details.vue')
            },

            { //人才管理
                path: '/talents_manage',
                name: 'talents_manage',
                meta: {
                    title: '人才管理',
                },
                component: () =>
                    import ('@/views/Home/B_Home/talents_manage/talents_manage.vue')
            },

            { //新线下招聘会
                path: '/job_fair_new',
                name: 'job_fair_new',
                meta: {
                    title: '线下招聘会',
                },
                component: () =>
                    import ('@/views/Home/B_Home/job_fair_new/job_fair_new.vue')
            },
            { //新线下招聘会详情
                path: '/job_fair_details_new',
                name: 'job_fair_details_new',
                meta: {
                    title: '招聘简章填写',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Home/B_Home/job_fair_new/job_fair_details/job_fair_details_new.vue')

            },
            { //个人中心
                path: '/person',
                name: 'person',
                meta: {
                    title: '个人中心',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Home/B_Home/person/person.vue')
            },
            { //更换手机号  
                path: '/changePhone',
                name: 'changePhone',
                meta: {
                    title: '更换手机号',
                },
                component: () =>
                    import ('@/views/Home/B_Home/person/changePhone/changePhone.vue')
            },
            { //修改密码
                path: '/changePassword',
                name: 'changePassword',
                meta: {
                    title: '修改密码',
                },
                component: () =>
                    import ('@/views/Home/B_Home/person/changePassword/changePassword.vue')
            },
            { //企业资料
                path: '/firm_data',
                name: 'firm_data',
                meta: {
                    title: '企业资料',
                },
                component: () =>
                    import ('@/views/Home/B_Home/firm_data/firm_data.vue')
            },
            { //企业资料详情
                path: '/firm_data_detail',
                name: 'firm_data_detail',
                meta: {
                    title: '企业资料详情',
                },
                component: () =>
                    import ('@/views/Home/B_Home/firm_data/firm_data_detail.vue')
            },
            { //联系客服
                path: '/kefu',
                name: 'kefu',
                meta: {
                    title: '联系客服',
                },
                component: () =>
                    import ('@/views/Home/B_Home/kefu/kefu.vue')
            },
        ]
    },



]

// 重复点击路由报错解决
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            // 如果从浏览器的前进或后退按钮触发跳转，恢复滚动位置
            return savedPosition;
        } else {
            // 否则，页面跳转后置顶
            return { x: 0, y: 0 };
        }
    }
})

export default router